import { render, staticRenderFns } from "./ModalCategoriaUniversidad.vue?vue&type=template&id=1f65bf66"
import script from "./ModalCategoriaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalCategoriaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports